import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import React from "react";

const ServiceSingleButton = ({ blok }) => (
  <div className="singlebutton-wrap-outer">
    <div className="singlebutton-wrap inner-wrap" 
    style={{ display: `${blok.flex}`}}
    {...storyblokEditable(blok)}>
      {blok.link && (
        <Link href={blok.link} >
          <button className="button-default-width">{blok.button}</button>
        </Link>
      )}
      {blok.linknewtab && (
        <Link target="_blank" href={blok.linknewtab} >
            <button className="button-default-width">
              {blok.buttonnewtab}
            </button>
        </Link>
      )}
    </div>
  </div>
);

export default ServiceSingleButton;
